import { Reveal, SectionHeading } from "./Reveal";
import { Marigold } from "./motifs";

const Testimonials = () => (
    <section id="reviews" data-testid="testimonials-section" className="relative py-28 sm:py-40">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
            <SectionHeading
                eyebrow="Kind Words"
                title={<>What Our <em className="italic text-[#E2BA03] [text-shadow:0_1px_0_#472500]">Customers Say</em></>}
                testId="testimonials-heading"
                className="mb-16"
            />
            <Reveal>
                <div
                    className="relative rounded-[2rem] border-2 border-dashed border-[#472500]/25 bg-[#F7F4EC] px-8 py-20 sm:py-28 text-center overflow-hidden"
                    data-testid="testimonials-placeholder"
                >
                    <Marigold className="absolute -left-10 -top-10 w-40 h-40 text-[#EA580C] opacity-10 animate-spin-slower" />
                    <Marigold className="absolute -right-10 -bottom-10 w-40 h-40 text-[#E2BA03] opacity-10 animate-spin-slower" />
                    <p className="font-display italic text-3xl sm:text-4xl text-[#472500]/80">
                        Client reviews coming soon
                    </p>
                    <p className="mt-4 text-sm sm:text-base text-[#472500]/55 max-w-md mx-auto">
                        We're gathering kind words from our festive families — check back shortly.
                    </p>
                    <div
                        className="mt-10 mx-auto max-w-lg rounded-xl border border-[#E2BA03]/60 bg-[#E2BA03]/10 px-6 py-4 text-left"
                        data-testid="testimonials-owner-note"
                    >
                        <p className="text-[11px] uppercase tracking-[0.25em] text-[#472500]/60 font-semibold mb-1.5">
                            Note for the site owner — remove before launch
                        </p>
                        <p className="text-sm text-[#472500]/75 leading-relaxed">
                            Add real reviews here once permission is obtained from customers — Festive Theory
                            has a "Client Reviews" Instagram Highlight that can be used as a source, with the
                            customer's permission.
                        </p>
                    </div>
                </div>
            </Reveal>
        </div>
    </section>
);

export default Testimonials;
